import { createClient } from '@supabase/supabase-js'
import config from './config.local'

const { url: supabaseUrl, anonKey: supabaseAnonKey } = config.supabase

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'appetite-admin-auth',
    storage: window.localStorage
  }
}) 